// Where a buyer stands on an engagement that has been suspended (#1299) - worked out from their own timeline by the API.
export enum BuyerCatchUpState {
    SUSPENDED = 0,
    CATCHING_UP = 1,
    SYNCHRONIZED = 2,
}

export const BuyerCatchUpStates = [
    { id: BuyerCatchUpState.SUSPENDED, name: 'Suspended' },
    { id: BuyerCatchUpState.CATCHING_UP, name: 'Catching up' },
    { id: BuyerCatchUpState.SYNCHRONIZED, name: 'Synchronized' },
];
